import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocalStorageKey } from "app/types";
import { AppUser, UserState } from "features/user/types";
import { updateAccount, getAccountUsers } from "features/account/api";
import {
  createChildAccount,
  updateUser,
  deleteChild,
  updateChildStatus,
} from "features/player/api";

const initialState: UserState = {
  parent: null,
  active: null,
  users: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setActiveUser(state: UserState, action: PayloadAction<AppUser>) {
      state.active = action.payload;
      localStorage.setItem(LocalStorageKey.ACTIVE_USER_UID, action.payload.uid);
      localStorage.setItem(LocalStorageKey.LAST_ACTIVE_USER_UID, action.payload.uid);
    },
    clearUser(state: UserState) {
      state.parent = null;
      state.active = null;
      state.users = [];
      localStorage.removeItem(LocalStorageKey.ACTIVE_USER_UID);
    },
  },
  extraReducers: (builder) => {
    builder
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(getAccountUsers.fulfilled, (state: UserState, action: PayloadAction<any>) => {
        state.parent = action.payload.parent;
        state.users = action.payload.users;
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(createChildAccount.fulfilled, (state: UserState, action: PayloadAction<any>) => {
        state.users = [...state.users, action.payload];
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(updateAccount.fulfilled, (state: UserState, action: PayloadAction<any>) => {
        const updatedUser = action.payload;
        state.users = state.users.map((user) =>
          user.uid === updatedUser.uid ? updatedUser : user,
        );
        state.parent = updatedUser;
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(updateUser.fulfilled, (state: UserState, action: PayloadAction<any>) => {
        const updatedUser = action.payload;
        state.users = state.users.map((user) =>
          user.uid === updatedUser.uid ? updatedUser : user,
        );
        if (state.active?.uid === updatedUser.uid) {
          state.active = updatedUser;
        }
        if (state.parent?.uid === updatedUser.uid) {
          state.parent = updatedUser;
        }
      })
      .addCase(deleteChild.fulfilled, (state: UserState, action: PayloadAction<string>) => {
        const uid = action.payload;
        state.users = state.users.filter((user) => user.uid !== uid);
        if (state.active?.uid === uid) {
          state.active = null;
        }
      })
      .addCase(updateChildStatus.fulfilled, (state: UserState, action: PayloadAction<AppUser>) => {
        const updatedUser = action.payload;
        state.users = state.users.map((user) =>
          user.uid === updatedUser.uid ? updatedUser : user,
        );
        if (state.active?.uid === updatedUser.uid) {
          state.active = updatedUser;
        }
      });
  },
});

export const actions = { ...userSlice.actions };

export default userSlice.reducer;
